// types
import { SortByCategoriesStateSchema } from "../types/sortByCategoriesTypes";

export const getSortByCategoriesSlice = (state: SortByCategoriesStateSchema) =>
  state.sortByCategories;
